import type { DividerProps } from '@hover/blueprint';
import { Divider as SystemDivider } from '@hover/blueprint';
import React from 'react';

import { DesignerPartner } from '../../constants/partners';

export enum LOGO_FILTER {
  TEXT = 'text',
  TRANSPARENT = 'transparent',
  PILL = 'pill',
  CUSTOM = 'custom',
}

export const BRAND_WITH_CUSTOM_LOGO = [DesignerPartner.PELLA];

type LogoFilterType = (typeof LOGO_FILTER)[keyof typeof LOGO_FILTER];

export const VerticalDivider = (props: DividerProps) => (
  <SystemDivider
    borderBottomWidth={0}
    borderColor="neutral.200"
    borderLeftWidth="1px"
    height="100%"
    margin="0"
    width={0}
    {...props}
  />
);

export const getFilterForLogo = (
  url?: string,
  partner?: DesignerPartner | null,
): LogoFilterType => {
  if (partner && BRAND_WITH_CUSTOM_LOGO.indexOf(partner) !== -1) {
    return LOGO_FILTER.CUSTOM;
  }

  if (!url) return LOGO_FILTER.TEXT;

  const extension = url.split('.').pop()?.split('?')[0];

  // NOTE: Until we have a better color logo manipulation, we will put all the logos in a pill
  // LOGO_FILTER.TRANSPARENT will be used for svg and png logos once we make sure they are white
  switch (extension) {
    case 'svg':
    case 'png':
    case 'jpg':
    case 'jpeg':
      return LOGO_FILTER.PILL;
    default:
      return LOGO_FILTER.TEXT;
  }
};
